import React from 'react'
import './index.scss'
import ArrowButton from '@Components/Buttons/Arrow'
import { Maybe } from '@Types'
import clsx from 'clsx'
import { PaginationBody, PaginationInfo } from '@Entities/pagination'

interface PaginationComponentProps {
    limit: number
    paginationPages: Maybe<PaginationInfo>
    limitPages?: boolean
    onChange: (body: PaginationBody) => void
}

const PaginationComponent = (props: PaginationComponentProps) => {
    const setCurrentPage = (page = 1) => {
        if (!props.paginationPages) {
            return
        }

        const pagination: PaginationBody = {
            page,
            limit: props.limit,
            refined: props.paginationPages.refined,
        }

        props.onChange(pagination)
    }

    const { paginationPages, limitPages = true } = props
    const currentPage = paginationPages ? paginationPages.currentPage : 1
    const lastPage = paginationPages
        ? limitPages && paginationPages.cappedLastPage
            ? paginationPages.cappedLastPage
            : paginationPages.lastPage
        : 1
    const isFirstPage = currentPage === 1
    const isLastPage = currentPage === lastPage

    /* Calculate which page numbers we should see in the component */
    const pagesToDisplay = Array.from({ length: 5 }, (x, i) => i + currentPage - 2)
        .filter((num) => num > 0 && num <= Math.min(Math.max(currentPage + 1, 3), lastPage))
        .slice(Math.min(lastPage, 3) * -1)

    return (
        <div className="pagination-container">
            {/* FIRST BUTTON*/}
            <div
                className={clsx('first-last', isFirstPage && 'disabled')}
                onClick={() => !isFirstPage && setCurrentPage(1)}
            >
                <p>FIRST</p>
            </div>

            {/* BACK ARROW*/}
            <span className={clsx('arrow-left', isFirstPage && 'disabled-left')}>
                <ArrowButton
                    mainColor
                    type="left"
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={isFirstPage}
                />
            </span>

            {/* PAGE NUMBERS */}
            {pagesToDisplay.map((page) => (
                <div
                    className={clsx(page === currentPage ? 'current-page' : 'non-current-page')}
                    onClick={() => setCurrentPage(page)}
                    key={page}
                >
                    <p>{page}</p>
                </div>
            ))}

            {/* NEXT ARROW */}
            <span className={clsx('arrow-right', isLastPage && 'disabled-right')}>
                <ArrowButton
                    mainColor
                    type="right"
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={isLastPage}
                />
            </span>

            {/* LAST BUTTON */}
            <div
                className={clsx('first-last', isLastPage && 'disabled')}
                onClick={() => !isLastPage && setCurrentPage(lastPage)}
            >
                <p>LAST</p>
            </div>
        </div>
    )
}

export default PaginationComponent
